import { runtime } from "./runtime.mjs";
function openWindow(url, target = "_blank") {
  runtime.openWindow(url, target);
}
export {
  openWindow
};
//# sourceMappingURL=window-open.mjs.map
